import { supabase, redirectToLogin } from "./supabase";

/**
 * fetch wrapper for our API. Attaches the current Supabase access token
 * (auto-refreshed by supabase-js); a 401 clears the session and bounces to
 * the in-app login.
 */
export async function authFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
): Promise<Response> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const headers = new Headers(init.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    await supabase.auth.signOut();
    redirectToLogin();
  }
  return res;
}
